import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "z-3" };
const _hoisted_2 = { class: "mt-1 py-3 rounded-3 alertListModal overflow-y-auto" };
const _hoisted_3 = { class: "w-100 d-flex justify-content-center" };
import { useStore } from "vuex";
/* eslint-disable no-undef */
import { computed, onMounted, ref, watch } from "vue";
import WarningMobileCard from "@/components/cards/WarningMobileCard.vue";
import LoadContentButton from "@/components/buttons/LoadContentButton.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AlertsInMobileCard',
    setup(__props) {
        const store = useStore();
        const alertListState = ref(false);
        const activeSelect = computed(() => store.getters.getSelectName);
        const consumerSettings = computed(() => store.getters.getConsumerSettings);
        const alertsData = computed(() => store.getters["alerts/alertsData"]);
        const token = computed(() => store.getters.getToken);
        const existsNotReadAlerts = ref(false);
        const companyData = computed(() => store.getters.getCompany);
        const warningPerPage = ref(30);
        const incrementPagination = () => {
            warningPerPage.value += 30;
        };
        const getWarnings = async () => {
            await store.dispatch('alerts/GetAlerts', {
                filter: { company_id: companyData.value.id, status: 'active', perPage: warningPerPage.value },
                token: token.value
            });
        };
        const handleExistsNotReadAlerts = () => {
            const mockUpVariable = ref(false);
            alertsData.value.forEach((alertInArray) => {
                if (!alertInArray.is_read) {
                    mockUpVariable.value = true;
                }
            });
            existsNotReadAlerts.value = mockUpVariable.value;
        };
        const handleAlertState = () => {
            alertListState.value = !alertListState.value;
            setTimeout(() => {
                alertListState.value ?
                    store.dispatch('setSelectData', { selectName: 'WarningsSelect', selectWrapperDiv: '.alertListModal' })
                    : store.dispatch('clearSelectData');
            }, 0);
        };
        const handleAlertModalState = (alertToShow) => {
            store.dispatch('alerts/setShowAlertModalData', {
                state: true,
                alertToShow: alertToShow
            });
            handleAlertState();
        };
        const verifySelectState = () => {
            if (activeSelect.value !== 'WarningsSelect') {
                alertListState.value = false;
            }
        };
        onMounted(() => {
            handleExistsNotReadAlerts();
        });
        watch(activeSelect, () => {
            verifySelectState();
        });
        watch(warningPerPage, () => {
            getWarnings();
        });
        watch(alertsData, () => {
            handleExistsNotReadAlerts();
        }, { deep: true });
        /* eslint-enable no-undef */
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "fs-6 ms-2" }, "Avisos", -1)),
                    _createElementVNode("div", {
                        style: _normalizeStyle({ backgroundColor: consumerSettings.value.settings.primary_color }),
                        class: "line"
                    }, null, 4),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alertsData.value, (alert) => {
                        return (_openBlock(), _createBlock(WarningMobileCard, {
                            key: alert.id,
                            alert: alert,
                            userColor: consumerSettings.value.settings.primary_color,
                            onClick: ($event) => (handleAlertModalState(alert))
                        }, null, 8, ["alert", "userColor", "onClick"]));
                    }), 128)),
                    _createElementVNode("div", _hoisted_3, [
                        (alertsData.value.length === warningPerPage.value)
                            ? (_openBlock(), _createBlock(LoadContentButton, {
                                key: 0,
                                onClick: incrementPagination
                            }))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
